import { useEffect } from "react";

import { useBookerStore } from "../store";
import type { BookerState } from "../types";
import { getQueryParam } from "../utils/query-param";

export function useSyncBookingWithUrl(username: string, eventSlug: string, duration: number | null) {
  const date = getQueryParam("date");
  const slot = getQueryParam("slot");

  // treat zero- or null-duration events as “override” (no calendar)
  const isOverride = duration == null || duration === 0;

  useEffect(() => {
    if (isOverride) {
      // skip all calendar sync when override
      // (we drive UI purely via `booking_override` state)
      return;
    }

    // 1) On mount or URL change: push date/slot into store
    useBookerStore.setState({
      selectedDate: date,
      selectedTimeslot: slot,
    });
    const initialState: BookerState = slot ? "booking" : date ? "selecting_time" : "selecting_date";
    useBookerStore.setState({ state: initialState });

    // 2) On Back/Forward (popstate), keep URL , store in sync
    const onPop = () => {
      const date = getQueryParam("date");
      const slot = getQueryParam("slot");

      // Otherwise mirror the new URL state into our store
      useBookerStore.setState({
        selectedDate: date,
        selectedTimeslot: slot,
      });
      const newState: BookerState = slot ? "booking" : date ? "selecting_time" : "selecting_date";
      useBookerStore.setState({ state: newState });
    };

    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [username, eventSlug, isOverride, date, slot]);
}
